import React from "react";
import { useContext } from "react";
import ModalEnum from "../BaseModal/ModalEnum";
import ModalContext from "../../../context/ModalContext";

export interface IModalTriggerProps {
    modal: ModalEnum;
    children: React.ReactElement;
}

export default (props: IModalTriggerProps) => {
    const { children } = props;
    const { openModal } = useContext(ModalContext);
    const handleOpen = (ev) => {
        ev.preventDefault();
        openModal(props.modal);
    };

    return (
        <>
            {React.Children.map(children, child => {
                return React.cloneElement(child, { onClick: handleOpen });
            })}
        </>
    );
};
